import { render, staticRenderFns } from "./ProdutoWindow.vue?vue&type=template&id=67077366"
import script from "./ProdutoWindow.vue?vue&type=script&lang=js"
export * from "./ProdutoWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports